import { Component } from '@angular/core';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';
import {UserService} from '../../../app/services/user.service'
import { filter } from 'rxjs';
import { HttpClient ,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Component({
  selector: 'app-agent-payment-confirm',
  templateUrl: './agent-payment-confirm.component.html',
  styleUrls: ['./agent-payment-confirm.component.css']
})
export class AgentPaymentConfirmComponent {
  constructor(private router: Router,private UserService:UserService ,
    private route: ActivatedRoute,private http: HttpClient) {
      debugger
// this.confirm()
let currentRoute:any;
currentRoute = this.router?.routerState?.snapshot?.url;
this.route.paramMap.subscribe(params => {
 let id= params.get('token');
 if(id){
 this.paymentOrderData(id)
 }
});

setTimeout(() => {
  // this.route.queryParamMap.subscribe(resp => {
  //   console.log(resp)

  //   console.log(resp.get("encResp"))
  //     alert(resp.get("encResp"));
  //   })
}, 300);
// this.route.params.subscribe(params => {
//   console.log(params);
// });
// this.route.queryParamMap.subscribe(p => {

//   const keys = p.keys;
//   console.log('keysParam',keys);
//   keys.forEach(key => {
//     console.log(key);
//     console.log(key + " from query param ==== "+ p.get(key));
//   })
// })

// this.route.data.subscribe(p => {
//   console.log(p)
//   const keys = p['keys'];
//   console.log('key1Data',keys);
//   keys.forEach((key: string) => {
//     console.log('key1',key);
    
//     console.log(key + " from data ==== "+ p['get'](key));
//   })
// })


// console.log('sdd')
  }

  viewReceipt() {
    // this.ngOnInit()
    // this.router.navigate(['/receipt']); // Navigate to the receipt page or any other route
  }
  returnUrl1: string | null = null;
  encResp: string | null = null;
  orderNo: string | null = null;
  goBack() {
    let path:any=sessionStorage.getItem('urlAgentPath')
    // this.router.navigate(['/app/flight']); // Navigate to the homepage or any other route
    // this.router.navigate([path]); // Navigate to the homepage or any other route
    window.location.href = path

  }
  intercepts(req: HttpRequest<any>, next: HttpHandler) {
    if (req.method === 'POST' && req.body instanceof FormData) {
      // Log or modify FormData
    }
    return next.handle(req);
  }
  ngOnInit(): void {
    this.startTimer();



//     const form:any=document.querySelector('form')
   
//     const formDataString = localStorage.getItem('encResp');
//     form.addEventListener('submit', function(e:any) {
//       e.preventDefault()
//       let formdata:any=new FormData(form)
// for(let item of formdata){
// console.log(item[0],item[1])
// }
//   })
// if (formDataString) {
//   const formData = JSON.parse(formDataString);
//   console.log('Form Data:', formData);
//   alert(`FormencResp: ${formData}`);

// } else {
//   alert(`FormencResp: ${'formData'}`);

//   console.error('No formData found in localStorage');
// }
    // this.route.queryParamMap.subscribe(params => {
    //   console.log('Params object:', params);
    //   this.returnUrl1 = params.get('returnUrl1');
    //   this.encResp = params.get('encResp');
    //   this.orderNo = params.get('orderNo');
  
    //   console.log('returnUrl1:', this.returnUrl1);
    //   console.log('encResp:', this.encResp);
    //   console.log('orderNo:', this.orderNo);
    //   // alert(`encResp: ${this.encResp}`);

    //   if (this.returnUrl1 && this.encResp && this.orderNo) {
    //     alert(`encResp: ${this.encResp}`);
    //   } else {
    //     console.error('Query parameters missing or incorrect');
    //   }
    // });
  }
  // ngOnInit(): void {
  //   this.route.queryParamMap.subscribe(params => {
  //     this.returnUrl1 = params.get('returnUrl1');
  //     this.encResp = params.get('encResp');
  //     this.orderNo = params.get('orderNo');

  //     if (this.returnUrl1 && this.encResp && this.orderNo) {
  //       console.log('returnUrl1:', this.returnUrl1);
  //       console.log('encResp:', this.encResp);
  //       console.log('orderNo:', this.orderNo);
        
  //       alert(`encResp: ${this.encResp}`);
  //       this.getBookedByUUid()

  //     } else {
  //       console.error('Query parameters missing or incorrect');
  //     }
  //   });

  // }

 
 
  // ngOnInit(): void {
  //   this.http.post<any>('https://vapt.gilpinonline.com/payment/payment/cca/confirm', null, { responseType: 'text' as 'json' }).subscribe((response:any) => {
  //     console.log('Response:', response);

  //     const formData = this.parseFormData(response);
  //     console.log('formData:', formData);

  //     this.returnUrl1 = formData.returnUrl1 || null;
  //     this.encResp = formData.encResp || null;
  //     this.orderNo = formData.orderNo || null;

  //     console.log('returnUrl1:', this.returnUrl1);
  //     console.log('encResp:', this.encResp);
  //     console.log('orderNo:', this.orderNo);
  //   });
  // }
  parseFormData(response: string): any {
    // Implement parsing logic based on the format of the response
    // This is a simple example if response is URL encoded
    const formData: any = {};
    const pairs = response.split('&');
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      formData[decodeURIComponent(key)] = decodeURIComponent(value);
    }
    return formData;
  }
  // ngOnInit(): void {

    // console.log(this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(() => {
       
    //   }))

     

    
    // const navigation = this.router.getCurrentNavigation();
    // console.log(navigation)
    // if (navigation?.extras.state) {
    //   const returnUrl = navigation.extras.state['returnUrl1'];
    //   console.log(returnUrl)

    // }
  // }

  change(f:any){
    console.log(f.name)
   
  }
confirm() {
  
  this.UserService.confirm().subscribe(response => {
    // Handle the response and redirect to CCAvenue payment page

    // const { accessCode, encRequest } = response.body;
    // console.log(response)

    // console.log(accessCode)
    // console.log(encRequest)

    // const form = document.createElement('form');
    // form.method = 'POST';
    // form.action = 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
    // form.target = '_blank'; // Change target to open in a new window

    // const accessCodeInput = document.createElement('input');
    // accessCodeInput.type = 'hidden';
    // accessCodeInput.name = 'access_code';
    // accessCodeInput.value = accessCode;
    // form.appendChild(accessCodeInput);

    // const encRequestInput = document.createElement('input');
    // encRequestInput.type = 'hidden';
    // encRequestInput.name = 'encRequest';
    // encRequestInput.value = encRequest;
    // form.appendChild(encRequestInput);

    // document.body.appendChild(form);
    // form.submit();
    
  });
}

getBookedByUUid(){
let request:any={
   orderId:this.orderNo,
   responseData:this.encResp,
   responseStatus:'S'
}
  this.UserService.ccaOrder(request)
  .subscribe({
    next : (res:any) => {
      if(res) {

      } else {
      } 
    },error : (err) => {

    }
  }
)


}
confirmationData:any
paymentOrderData(orderID:any){
  let request:any={
     orderId:this.orderNo,
     responseData:this.encResp,
     responseStatus:'S'
  }
    this.UserService.paymentOrderData(orderID)
    .subscribe({
      next : (res:any) => {
        if(res) {
  this.confirmationData=res
        } else {
        } 
      },error : (err) => {
  
      }
    }
  )
  
  
  }


countdown: number = 20;
interval: any;


startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      this.goBack()
      clearInterval(this.interval);
      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second
}
  
}
